import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useGlobalContext } from '../../../context/ContextGlobal'
import { TryCatch } from '../../../utils/general'
import { getSubDocument, getSubDocuments, updateDocument, updateSubDocument } from '../../../firebase/firestore'
import useCollaborator from './useCollaborator'
import { PagBankAssinatura } from '../../../api/pagBank'
import { Path } from '../../../router/paths'

const useCollaboratorSelectionHistory = () => {
  const { user, Authentication } = useCollaborator()

  const { setAlerts, setLoading, loading, formContext, setFormContext, setUser, alerts } = useGlobalContext()

  const { token, paymentId } = useParams()

  const navigate = useNavigate()

  const uid = user.id

  // const navigate = useNavigate()

  const CancellPlanInCollab = async (plan) => {
    // cria um novo plano
    const newPlan = {
      status: 'canceled',
    }

    const getPayments = await getSubDocuments('colaboradores', user.id, 'payments')

    // coleta pagamentos processados com cupons e ve se pode deleta-los
    const paymentsWithCoupon = getPayments
      .filter((payments) => payments?.cupomSelected)
      .map((payments) => ({
        coupon: payments?.cupomSelected?.codCupom,
        status: payments?.status,
        statusOld: payments?.statusOld,
        canCancel: payments?.canCancel,
      }))
    const canCancelCoupon = paymentsWithCoupon.filter((payment) => payment?.canCancel)

    // console.log(paymentsWithCoupon)
    // console.log(canCancelCoupon)

    const updateCollab = {
      lastPayment: '',
    }

    // se puder cancelar o cupon ele retira do cadastro
    if (canCancelCoupon.length > 0) {
      const cuponsAplyeds = user?.cupons
      canCancelCoupon.forEach((payment) => {
        if (payment.coupon && cuponsAplyeds?.[payment.coupon]) {
          delete cuponsAplyeds[payment.coupon]
        }
      })

      updateCollab.cupons = cuponsAplyeds
    }

    const subscriptionId = plan?.subscriptionId || null

    if (subscriptionId) {
      try {
        await PagBankAssinatura().cancel(subscriptionId, {})
      } catch (e) {
        console.error(e.message)
      }
    }

    await updateSubDocument('colaboradores', user.id, 'plans', plan.idPlan, newPlan)
    await updateDocument('colaboradores', user.id, updateCollab)
    await setUser((prev) => ({ ...prev, ...updateCollab }))
    setAlerts((prev) => [
      ...prev,
      {
        title: 'Assinatura Cancelada',
        msg: `Sua assinatura foi cancelada com sucesso!`,
        type: 'success',
      },
    ])

    return navigate(Path.CollabSignPlan(token))
  }

  const HandleCancellPlanInCollab = async (plan) => {
    await TryCatch(
      async () => {
        await CancellPlanInCollab(plan)
      },
      setLoading,
      setAlerts,
    )
  }

  const getForm = async () => {
    await Authentication()

    const getPayment = await getSubDocument('colaboradores', uid, 'payments', paymentId)

    setFormContext({ ...getPayment })
  }

  const FetchGetForm = async () => {
    await TryCatch(getForm, setLoading, setAlerts)
  }

  useEffect(() => {
    FetchGetForm()
  }, [])

  return { token, loading, FetchGetForm, formContext, HandleCancellPlanInCollab, alerts, setAlerts }
}

export default useCollaboratorSelectionHistory
